 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae":"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae","activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index":"activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index","activty-daren-bx~new-media-download~new-media-download-sub-index":"activty-daren-bx~new-media-download~new-media-download-sub-index","activty-daren-bx":"activty-daren-bx","new-media-download~new-media-download-sub-index":"new-media-download~new-media-download-sub-index","new-media-download":"new-media-download","new-media-download-sub-index":"new-media-download-sub-index","activty-sign-in~channel-coupon~multi-category":"activty-sign-in~channel-coupon~multi-category","channel-coupon":"channel-coupon","activty-new-user~activty-sign-in~order-paySuccess":"activty-new-user~activty-sign-in~order-paySuccess","activty-sign-in":"activty-sign-in","multi-category":"multi-category","protocol-qualification-content":"protocol-qualification-content","activty-douyin":"activty-douyin","activty-iphone12":"activty-iphone12","activty-new-user":"activty-new-user","order-paySuccess":"order-paySuccess","activty-sign-in-bill":"activty-sign-in-bill","common-open-app":"common-open-app","coupon":"coupon","coupon-list":"coupon-list","coupon-square":"coupon-square","hostingpage-machine":"hostingpage-machine","hostingpage-sservice":"hostingpage-sservice","instruct":"instruct","instruct-detail":"instruct-detail","logout-cancelFail":"logout-cancelFail","logout-index":"logout-index","logout-phoneCheck":"logout-phoneCheck","logout-protocol":"logout-protocol","logout-reason":"logout-reason","logout-success":"logout-success","message-center":"message-center","platform-independent-service":"platform-independent-service","platform-sold-out":"platform-sold-out","protocol-qualification":"protocol-qualification","protocol-qualification-list":"protocol-qualification-list","protocol-service-guarantee":"protocol-service-guarantee","question-answer":"question-answer","sentry":"sentry","setting-privacy":"setting-privacy","setting-recommend":"setting-recommend","setting-userInfo":"setting-userInfo"}[chunkId]||chunkId) + "." + {"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae":"eadd0b9c","activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index":"8dbda8f1","activty-daren-bx~new-media-download~new-media-download-sub-index":"103991b2","activty-daren-bx":"da9937a6","new-media-download~new-media-download-sub-index":"187fe860","new-media-download":"92f9fb11","new-media-download-sub-index":"4aaa4854","activty-sign-in~channel-coupon~multi-category":"67de5cc0","channel-coupon":"8b5a633c","activty-new-user~activty-sign-in~order-paySuccess":"f32e7435","activty-sign-in":"5df86997","multi-category":"f33f39d3","protocol-qualification-content":"1cfa6ac0","activty-douyin":"b9d86997","activty-iphone12":"c0b47281","activty-new-user":"e1693506","order-paySuccess":"d9718f2d","activty-sign-in-bill":"87528fd4","common-open-app":"8e092778","coupon":"2e55b089","coupon-list":"35b669e9","coupon-square":"6eb37660","hostingpage-machine":"bf1e4bca","hostingpage-sservice":"60531518","instruct":"fb9c2083","instruct-detail":"2e222587","logout-cancelFail":"c2b2abb2","logout-index":"708a7abd","logout-phoneCheck":"3ee2d066","logout-protocol":"d9fb1ae9","logout-reason":"3dcf102d","logout-success":"0f58e236","message-center":"11bfc846","platform-independent-service":"30205c8a","platform-sold-out":"d6cec149","protocol-qualification":"81d41380","protocol-qualification-list":"3677749d","protocol-service-guarantee":"dee5e7bf","question-answer":"7d1bfad0","sentry":"abfea7b5","setting-privacy":"e73d863a","setting-recommend":"8c7657f5","setting-userInfo":"2785950d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activty-daren-bx":1,"new-media-download~new-media-download-sub-index":1,"new-media-download":1,"new-media-download-sub-index":1,"channel-coupon":1,"activty-sign-in":1,"multi-category":1,"protocol-qualification-content":1,"activty-douyin":1,"activty-iphone12":1,"activty-new-user":1,"order-paySuccess":1,"activty-sign-in-bill":1,"coupon":1,"coupon-list":1,"coupon-square":1,"hostingpage-machine":1,"hostingpage-sservice":1,"instruct":1,"instruct-detail":1,"logout-cancelFail":1,"logout-index":1,"logout-phoneCheck":1,"logout-protocol":1,"logout-reason":1,"logout-success":1,"message-center":1,"platform-independent-service":1,"platform-sold-out":1,"protocol-qualification":1,"protocol-qualification-list":1,"protocol-service-guarantee":1,"question-answer":1,"setting-privacy":1,"setting-recommend":1,"setting-userInfo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae":"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae","activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index":"activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index","activty-daren-bx~new-media-download~new-media-download-sub-index":"activty-daren-bx~new-media-download~new-media-download-sub-index","activty-daren-bx":"activty-daren-bx","new-media-download~new-media-download-sub-index":"new-media-download~new-media-download-sub-index","new-media-download":"new-media-download","new-media-download-sub-index":"new-media-download-sub-index","activty-sign-in~channel-coupon~multi-category":"activty-sign-in~channel-coupon~multi-category","channel-coupon":"channel-coupon","activty-new-user~activty-sign-in~order-paySuccess":"activty-new-user~activty-sign-in~order-paySuccess","activty-sign-in":"activty-sign-in","multi-category":"multi-category","protocol-qualification-content":"protocol-qualification-content","activty-douyin":"activty-douyin","activty-iphone12":"activty-iphone12","activty-new-user":"activty-new-user","order-paySuccess":"order-paySuccess","activty-sign-in-bill":"activty-sign-in-bill","common-open-app":"common-open-app","coupon":"coupon","coupon-list":"coupon-list","coupon-square":"coupon-square","hostingpage-machine":"hostingpage-machine","hostingpage-sservice":"hostingpage-sservice","instruct":"instruct","instruct-detail":"instruct-detail","logout-cancelFail":"logout-cancelFail","logout-index":"logout-index","logout-phoneCheck":"logout-phoneCheck","logout-protocol":"logout-protocol","logout-reason":"logout-reason","logout-success":"logout-success","message-center":"message-center","platform-independent-service":"platform-independent-service","platform-sold-out":"platform-sold-out","protocol-qualification":"protocol-qualification","protocol-qualification-list":"protocol-qualification-list","protocol-service-guarantee":"protocol-service-guarantee","question-answer":"question-answer","sentry":"sentry","setting-privacy":"setting-privacy","setting-recommend":"setting-recommend","setting-userInfo":"setting-userInfo"}[chunkId]||chunkId) + "." + {"activty-daren-bx~activty-sign-in~channel-coupon~multi-category~new-media-download~new-media-download~b16106ae":"31d6cfe0","activty-daren-bx~channel-coupon~new-media-download~new-media-download-sub-index":"31d6cfe0","activty-daren-bx~new-media-download~new-media-download-sub-index":"31d6cfe0","activty-daren-bx":"e91ff4c5","new-media-download~new-media-download-sub-index":"22fc8d1e","new-media-download":"76bb7528","new-media-download-sub-index":"47fcd878","activty-sign-in~channel-coupon~multi-category":"31d6cfe0","channel-coupon":"f24c54be","activty-new-user~activty-sign-in~order-paySuccess":"31d6cfe0","activty-sign-in":"a068a994","multi-category":"9f745bc9","protocol-qualification-content":"8ce622c2","activty-douyin":"ea220742","activty-iphone12":"1d469cac","activty-new-user":"64908eb9","order-paySuccess":"53f314b0","activty-sign-in-bill":"1037e9a8","common-open-app":"31d6cfe0","coupon":"c54cf170","coupon-list":"f259be57","coupon-square":"1a85fa89","hostingpage-machine":"86b1c954","hostingpage-sservice":"4774fdc5","instruct":"eddb8208","instruct-detail":"22e95c6a","logout-cancelFail":"81d11523","logout-index":"b43cd61d","logout-phoneCheck":"6c443fca","logout-protocol":"f96c9e3f","logout-reason":"5aa50a08","logout-success":"1da7d324","message-center":"6e1e0bd2","platform-independent-service":"96f1b32b","platform-sold-out":"bcb09a87","protocol-qualification":"8890bee6","protocol-qualification-list":"8890bee6","protocol-service-guarantee":"5770ceda","question-answer":"46c9cf63","sentry":"31d6cfe0","setting-privacy":"1b19e12a","setting-recommend":"ce11f7ea","setting-userInfo":"0f1f51a1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://s1.zhuanstatic.com/zlj/zljzz_mall_h5/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
